import React from 'react';
import { BaseSlido } from '@modules/core/components/BaseSlido';
import { CaseDetails } from '@modules/opportunities/presentation/pages/CaseCreation/components/CaseDetails';
import { Box, Text } from '@huspy/briks-web';
import { useTranslation } from 'react-i18next';

type CaseDetailsSlidoType = {
  bankApplicationId: string;
  opportunityId: string;
  isOpen: boolean;
  close: () => void;
};

export const CaseDetailsSlido = ({
  isOpen,
  bankApplicationId,
  opportunityId,
  close,
}: CaseDetailsSlidoType) => {
  const { t } = useTranslation();

  return (
    <BaseSlido
      title={ (
        <Text style={ { fontSize: '32px' } } weight='semiBold' p='8'>
          {t('opportunity.caseDetails.title')}
        </Text>
      ) }
      opened={ isOpen }
      close={ close }
      size='xl'
    >
      <Box p='8'>
        <CaseDetails
          bankApplicationId={ bankApplicationId }
          opportunityId={ opportunityId }
        />
      </Box>
    </BaseSlido>
  );
};
